import { createSlice } from '@reduxjs/toolkit';

const modalSlice = createSlice({
  name: 'MODALS',
  initialState: [] as any[],
  reducers: {
    openModal: (state, action) => {
      return state.concat({
        modalType: action.payload.modalType,
        modalProps: action.payload.modalProps,
      });
    },
    closeModal: (state, action) => {
      return state.filter((modal) => modal.modalType !== action.payload);
    },
    closeLastModal: (state) => {
      return state.filter((modal) => state.indexOf(modal) !== state.length - 1);
    },
    closeAllModals: () => {
      return [];
    },
  },
});

export const { openModal, closeModal, closeLastModal, closeAllModals } = modalSlice.actions;

export default modalSlice.reducer;
